import { render } from "./Fail.vue?vue&type=template&id=607ca64d&ts=true"
import script from "./Fail.vue?vue&type=script&lang=ts"
export * from "./Fail.vue?vue&type=script&lang=ts"

import "./Fail.vue?vue&type=style&index=0&id=607ca64d&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__